<template>
    <a class="led-box" href="#">
      <span :class="`alert-${online ? 'success' : 'danger'}`">
      {{ online ? 'Online' : 'Offline' }}
      </span>
      <span class="led-light"
           :class="online ? 'led-green' : 'led-red'">
      </span>
    </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('connection', ['online'])
  }
}
</script>
<style scoped>

.led-box {
  height: 30px;
}

.led-box:hover {
  cursor: default;
}

.led-light {
  margin: -3px auto;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-block;
}

.led-red {
  background-color: #f00;
  box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px, rgba(255, 0, 0, 0.5) 0 2px 12px;
}

.led-green {
  background-color: #abff00;
  box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #89ff00 0 2px 12px;
}

</style>
